'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../../external/classnames/index.js');

var PropTypes = require('prop-types');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var FooterLinks = function FooterLinks(props) {
  var data = props.data,
      header = props.header,
      className = props.className;
  var classes = index['default']('lanl-footer-div', 'link-links-col', className);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes
  }, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("p", {
    className: "footer-section-header"
  }, header), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "list-unstyled ft-main-list"
  }, data.map(function (_ref) {
    var label = _ref.label,
        link = _ref.link;
    return /*#__PURE__*/React__default['default'].createElement("li", {
      key: label
    }, /*#__PURE__*/React__default['default'].createElement("a", {
      href: link,
      "aria-label": 'Go to ' + link
    }, label));
  }))));
};

FooterLinks.propTypes = {
  className: PropTypes__default['default'].string,
  data: PropTypes__default['default'].array,
  header: PropTypes__default['default'].string
};
FooterLinks.defaultProps = {
  data: [],
  header: ''
};
exports.FooterLinks = FooterLinks;
exports['default'] = FooterLinks;